import { useEffect, useState } from "react";
import { api, type AuditEntry } from "./api.ts";

export function AuditLog(props: { token: string }) {
  const [entries, setEntries] = useState<AuditEntry[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      try {
        const r = await api.listAudit(props.token);
        if (!cancelled) {
          setEntries(r.entries);
          setError(null);
        }
      } catch (err) {
        if (!cancelled) setError((err as Error).message);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [props.token]);

  return (
    <section className="card">
      <div className="card-header">
        <h3>Journal d'audit</h3>
      </div>
      {error && <div className="error">{error}</div>}
      {entries == null && !error && <div className="empty">Chargement…</div>}
      {entries != null && entries.length === 0 && <div className="empty">Aucune entrée pour le moment.</div>}
      {entries != null && entries.length > 0 && (
        <table className="data">
          <thead>
            <tr>
              <th>Quand</th>
              <th>Auteur</th>
              <th>Action</th>
              <th>Détail</th>
            </tr>
          </thead>
          <tbody>
            {entries.map((e) => (
              <tr key={e.id}>
                <td><code>{new Date(e.at).toLocaleString("fr-FR")}</code></td>
                <td>{e.actorEmail ?? <span className="muted">système</span>}</td>
                <td><code>{e.action}</code></td>
                <td>
                  <code style={{ fontSize: 11, whiteSpace: "pre-wrap" }}>
                    {JSON.stringify(e.payload)}
                  </code>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </section>
  );
}
